import React from 'react';
import PropTypes from 'prop-types';

import Img from '../Img';

import styles from './toast.scss';

export const ToastTypes = {
    INFO: 'info',
    SUCCESS: 'success',
    ERROR: 'error',
};

const icons = {
    info: '/img/v4/circle-info-white.svg',
    success: '/img/v4/circle-check-white.svg',
    error: '/img/v4/triangle-exclamation-white.svg',
};

const Toast = ({ closeToast, data }) => {
    const { title, message, type = ToastTypes.INFO, actionLabel, onAction } = data;
    return (
        <div className={`${styles.toast} ${styles[type]}`} onClick={(e) => e.stopPropagation()} data-testid={`toast.${type}`}>
            <div className={styles.toastContent}>
                <div className={styles.left}>
                    <Img src={icons[type]} />
                </div>
                <div className={styles.middle}>
                    <div className={styles.toastTitle} data-testid={`toast.${type}.title`}>{title}</div>
                    <p data-testid={`toast.${type}.message`}>{message}</p>
                    {actionLabel && onAction && (
                        <button
                            type="button"
                            className={styles.action}
                            onClick={() => onAction(closeToast)}
                            data-testid={`toast.${type}.action`}
                        >
                            {actionLabel}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

Toast.propTypes = {
    closeToast: PropTypes.func.isRequired,
    data: PropTypes.shape({
        title: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        actionLabel: PropTypes.string,
        onAction: PropTypes.func,
    }).isRequired,
};

export default Toast;
